import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Youtube, Mail, MapPin, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-slate-900 to-slate-950 text-white border-t border-cyan-500/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-cyan-400 to-blue-600 rounded-full flex items-center justify-center shadow-lg">
                <span className="text-white font-bold">KP</span>
              </div>
              <span className="font-bold text-cyan-400">Kingdom of Kush</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Empowering African youth to shape the future of the continent through democratic participation and progressive legislation.
            </p>
            <div className="flex gap-3 mt-4">
              <a href="#" className="w-9 h-9 bg-white/10 hover:bg-gradient-to-r hover:from-cyan-500 hover:to-blue-500 rounded-full flex items-center justify-center transition-all">
                <Facebook className="h-4 w-4" />
              </a>
              <a href="#" className="w-9 h-9 bg-white/10 hover:bg-gradient-to-r hover:from-cyan-500 hover:to-blue-500 rounded-full flex items-center justify-center transition-all">
                <Twitter className="h-4 w-4" />
              </a>
              <a href="#" className="w-9 h-9 bg-white/10 hover:bg-gradient-to-r hover:from-cyan-500 hover:to-blue-500 rounded-full flex items-center justify-center transition-all">
                <Linkedin className="h-4 w-4" />
              </a>
              <a href="#" className="w-9 h-9 bg-white/10 hover:bg-gradient-to-r hover:from-cyan-500 hover:to-blue-500 rounded-full flex items-center justify-center transition-all">
                <Youtube className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-cyan-400 mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/members" className="text-gray-400 hover:text-white transition-colors">Members</Link></li>
              <li><Link to="/plenary" className="text-gray-400 hover:text-white transition-colors">Plenary Sessions</Link></li>
              <li><Link to="/committees" className="text-gray-400 hover:text-white transition-colors">Committees</Link></li>
              <li><Link to="/documents" className="text-gray-400 hover:text-white transition-colors">Documents</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors">About Us</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="font-semibold text-cyan-400 mb-4">Resources</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Legislative Observatory</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Research & Analysis</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Policy Papers</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Media Center</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">FAQs</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-cyan-400 mb-4">Contact Us</h3>
            <ul className="space-y-3 text-sm text-gray-400">
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 mt-1 flex-shrink-0 text-orange-500" />
                <span>African Union Headquarters<br />Addis Ababa, Ethiopia</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 flex-shrink-0 text-orange-500" />
                <span>+251 11 551 7700</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 flex-shrink-0 text-orange-500" />
                <span>contact@africanyouthparliament.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © 2025 United States of Africa. Kingdom of Kush Youth Parliament. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-400">
            <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors">Terms of Use</a>
            <a href="#" className="hover:text-white transition-colors">Accessibility</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;